import { Component, ChangeDetectionStrategy, OnInit, Input, Output, EventEmitter, Injectable, OnChanges, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';
import { CommonService } from '../../../../commons/services/common.service';
import { ConstanteEcorec } from '../../../../recylog/application/constante.ecorec';

@Component({
    selector: 'app-detail-devis-supp',
    templateUrl: './detail-devis-supp.component.html',
    styleUrls: ['./detail-devis-supp.component.css'],
    standalone: false
})
export class DetailDevisSuppComponent implements OnInit {
  @Input() row;
  @Input() detail;
  @Input() rowIndex;
  @Input() notModif;
  @Input() listContenant = [];
  @Input() listAgence = [];
  @Input() isDroitModifDevis;

  @Output() closefunction = new EventEmitter<any>();
  @Output() saveDetailSuppFunction = new EventEmitter<any>();

  error = '';
  listExutoire = [];
  listZone = [];
  listTarifQte = [];

  @ViewChild('msg') msg;

  constructor(public common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    this.detail = this.detail || {};
    console.log(this.listAgence);    
    const lz = this.common.getType('listZone') || [];
    if (lz.length > 0 && lz[0]) {
      for (let i = 0; i < lz[0].length; i++) {
        this.listZone.push({
          id: parseInt(lz[1][i], 10),
          libelleObjetEntite: lz[0][i]
        });
      };
    }

    this.listZone.forEach(z => {
      if (this.row['zone'] && this.row['zone'].id === z.id) {
        this.row['zone'] = z;
      }
    });

    if (this.row['contenant'] && this.row['contenant'].id) {
      this.row['contenant'] = this.common.getObjetById(this.listContenant, this.row['contenant'].id);
    }
  }

  close() {
    this.closefunction.emit();
  }

  saveChange() {
    this.saveDetailSuppFunction.emit(this.row);
  }

  saveChangeTarifQte() {
    this.row['article'].isTarifQte = this.row.isTarifQte;
    this.saveChange();
  }

  searchExutoire(event) {
    const param = 6;

    return this.common.appelComboK3Fct( param, event ).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        const l = [{ id: 0, libelleObjetEntite: 'Tous' }];
        l.push(...datas.data);
        this.listExutoire = l;
      }
    });
  }

  saveTarifQte(event) {
    // this.row['article'] = this.row['article'] || {};
    this.row['article'].isTarifQte = this.row.isTarifQte;
    this.row['article'].isQteSupp = event.isQteSupp;
    this.row['article'].listTarifQte = event.listTarifQte;
    this.row['article'].listTarifQte.forEach(elt => {
      const qte = elt.quantite + '';
      const tarif = elt.tarif + '';
      elt.quantite = qte.replace(/,/g, '.');
      elt.tarif = tarif.replace(/,/g, '.');
    });

    // console.log(this.row['article']);
    this.saveChange();
  }

  showTarifQte() {
    // this.row['tarif'] = 0;
    // this.row['article'] = this.row['article'] || {};-
    if (this.row['article'] && this.row['article'].listTarifQte) {
      this.listTarifQte = this.row['article'].listTarifQte || [];
    } else {
      this.listTarifQte = [];
    }
  }

  hideModal() {
    this.listTarifQte = [];
    this.common.closeModal();
  }

  actualiseArticleApres(row?, elemclick?) {
    const event = row.article || { id: 0 };
    if (event && event.id) {
      this.getDetailArticle(event.id, row).then(data => {
        row['article'] = data !== null ? data[0] : {};
        row.modifArticle = true;
        row.description = data !== null ? data[0].libelle : '';

        const argTypeClient = this.detail['client'].type ? this.detail['client'].type.id : 0;
        let argZoneChantier = (this.detail['chantier'] && this.detail['chantier'].zone) ? this.detail['chantier'].zone.id : 1;
        if (argZoneChantier === 0) {
          argZoneChantier = this.detail['zone'] ? this.detail['zone'].id : 1;
        }
        const argGrilleTarif = row['article'].grilleTarif ? row['article'].grilleTarif : false;
        row.tarif = data !== null ? data[0].tarif || this.getTarifClientZone(argTypeClient, argZoneChantier, argGrilleTarif)
          : this.getTarifClientZone(argTypeClient, argZoneChantier, argGrilleTarif); // data !== null ? data[0].tarif : '';

        row.txTVA = data !== null ? data[0].tva : '';
        row.typeTarif = data !== null ? data[0].typeTarif : '';

        setTimeout(() => {
          $(elemclick).click();
        }, 150);


      });
    }
  }

  getDetailArticle(id, row) {
    const clef = '' + id;
    const param = {
      'servlet': 'DBGetArticle',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'forcerSerialisation': 'true',
      'data': ['DBGetArticle', clef, this.detail['client'] ? this.detail['client'].id : 0, this.detail['dateCreation'],
        this.detail['chantier'] ? this.detail['chantier'].id : 0, '' + (row.quantite || 0), '' + (row.contenant ? row.contenant.id || 0 : 0),
        '' + (row.articleContenantContenu ? row.articleContenantContenu.id || 0 : 0), '' + (row['exutoire'] ? row['exutoire'].id || 0 : 0),
        this.common.user[2], '0']
      // 'data': ['DBGetArticle', clef, 0, '01/01/2000',
      //   0, 0, 0, 0, 0, this.common.user[2], '0']
    };
    return this.common.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }

  getTarifClientZone(typeClient, zone, tarifArticle) {
    // console.log(typeClient);
    console.log('zone : ' + zone);
    // console.log(tarifArticle);

    if (typeClient === 0 || zone === 0 || !tarifArticle) {
      return 0;
    }

    let tarif = 0;
    switch (typeClient) {

      case ConstanteEcorec.CLIENT_PRO:
        switch (zone) {

          case ConstanteEcorec.ZONE_1:
            tarif = tarifArticle.tarifProZone1 || 0;
            break;
          case ConstanteEcorec.ZONE_2:
            tarif = tarifArticle.tarifProZone2 || 0;
            break;
          case ConstanteEcorec.ZONE_3:
            tarif = tarifArticle.tarifProZone3 || 0;
            break;
          case ConstanteEcorec.ZONE_4:
            tarif = tarifArticle.tarifProZone4 || 0;
            break;
          case ConstanteEcorec.ZONE_5:
            tarif = tarifArticle.tarifProZone5 || 0;
            break;
          case ConstanteEcorec.ZONE_6:
            tarif = tarifArticle.tarifProZone6 || 0;
            break;
          default:
            break;
        }
        ;
        break;
      case ConstanteEcorec.CLIENT_SEMIPRO:
        switch (zone) {

          case ConstanteEcorec.ZONE_1:
            tarif = tarifArticle.tarifSemiProZone1 || 0;
            break;
          case ConstanteEcorec.ZONE_2:
            tarif = tarifArticle.tarifSemiProZone2 || 0;
            break;
          case ConstanteEcorec.ZONE_3:
            tarif = tarifArticle.tarifSemiProZone3 || 0;
            break;
          case ConstanteEcorec.ZONE_4:
            tarif = tarifArticle.tarifSemiProZone4 || 0;
            break;
          case ConstanteEcorec.ZONE_5:
            tarif = tarifArticle.tarifSemiProZone5 || 0;
            break;
          case ConstanteEcorec.ZONE_6:
            tarif = tarifArticle.tarifSemiProZone6 || 0;
            break;
          default:
            break;
        }
        ;
        break;
      case ConstanteEcorec.CLIENT_CADRE:
        switch (zone) {

          case ConstanteEcorec.ZONE_1:
            tarif = tarifArticle.tarifCadreZone1 || 0;
            break;
          case ConstanteEcorec.ZONE_2:
            tarif = tarifArticle.tarifCadreZone2 || 0;
            break;
          case ConstanteEcorec.ZONE_3:
            tarif = tarifArticle.tarifCadreZone3 || 0;
            break;
          case ConstanteEcorec.ZONE_4:
            tarif = tarifArticle.tarifCadreZone4 || 0;
            break;
          case ConstanteEcorec.ZONE_5:
            tarif = tarifArticle.tarifCadreZone5 || 0;
            break;
          case ConstanteEcorec.ZONE_6:
            tarif = tarifArticle.tarifCadreZone6 || 0;
            break;
          default:
            break;
        }
        ;
        break;
      case ConstanteEcorec.CLIENT_PARTICULIER:
        switch (zone) {

          case ConstanteEcorec.ZONE_1:
            tarif = tarifArticle.tarifPartZone1 || 0;
            break;
          case ConstanteEcorec.ZONE_2:
            tarif = tarifArticle.tarifPartZone2 || 0;
            break;
          case ConstanteEcorec.ZONE_3:
            tarif = tarifArticle.tarifPartZone3 || 0;
            break;
          case ConstanteEcorec.ZONE_4:
            tarif = tarifArticle.tarifPartZone4 || 0;
            break;
          case ConstanteEcorec.ZONE_5:
            tarif = tarifArticle.tarifPartZone5 || 0;
            break;
          case ConstanteEcorec.ZONE_6:
            tarif = tarifArticle.tarifPartZone6 || 0;
            break;
          default:
            break;
        }
        ;
        break;
      default:
        break;
    }

    return tarif;
  }
}
